module.exports = __webpack_public_path__ + "img-dashboard/register/twitter.a544312d.png";